/* Jolturn product page, CRO rebuild 2 Oct 2026.

   1. Kaching tiers: adds the subtitle, badge, per-car price and delivery line
      the app does not render, read live from the widget so it stays right if
      prices change in Kaching. Idempotent: it only writes when text differs,
      so its own writes do not loop through the MutationObserver.
   2. Sticky bar: shows the chosen pack and opens a sheet to change it.
   3. Gallery progress bar on phones.
   4. Dispatch date recalculated on the visitor's device, so a cached page
      never shows yesterday's date.

   Fails safe: if Kaching never renders, the skeleton is removed after a few
   seconds and the plain Add to cart button still works. */
(function () {
  'use strict';

  var purchase = document.querySelector('[data-jt-purchase]');
  if (!purchase) return;

  /* Line breaking lives in theme.js (site-wide). */

  var cfg = {};
  try {
    var cfgNode = document.querySelector('[data-jt-picker-config]');
    if (cfgNode) cfg = JSON.parse(cfgNode.textContent);
  } catch (e) { cfg = {}; }
  cfg.tiers = cfg.tiers || [];

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }

  var CHECK_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.4l2.9 2.9 6.1-6.6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ------------------------------------------------------------ money */

  function parseMoney(text) {
    if (!text) return null;
    var m = String(text).match(/(\D*?)(\d[\d,]*(?:\.\d{1,2})?)/);
    if (!m) return null;
    var value = parseFloat(m[2].replace(/,/g, ''));
    if (!isFinite(value)) return null;
    return { prefix: (m[1] || '').trim() || '£', cents: Math.round(value * 100) };
  }
  function formatMoney(cents, prefix) {
    var whole = cents % 100 === 0;
    var str = whole ? String(Math.round(cents / 100)) : (cents / 100).toFixed(2);
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (prefix || '£') + parts.join('.');
  }
  function cleanText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    $$('.kaching-bundles__bar-price__unit-label, .visually-hidden', clone).forEach(function (n) { n.parentNode.removeChild(n); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }
  function prettyTitle(t) {
    t = (t || '').replace(/\s+/g, ' ').trim();
    /* "2 CARS" reads better as "2 cars" in the sticky bar, but VAC and AIR are
       product names and stay in capitals: "2 AIRs", not "2 airs". */
    if (t && t === t.toUpperCase()) {
      t = t.toLowerCase().replace(/\b(vac|air)(s?)\b/g, function (m, w, s) { return w.toUpperCase() + s; });
    }
    return t;
  }

  /* ------------------------------------------------------------ Kaching model */

  var block = null;
  var qtyById = null;

  function quantities() {
    if (qtyById) return qtyById;
    var map = {};
    var sources = [];
    if (block && block.getAttribute('deal-block')) sources.push(block.getAttribute('deal-block'));
    $$('script.kaching-bundles-deal-block-settings').forEach(function (s) { sources.push(s.textContent); });
    sources.forEach(function (raw) {
      try {
        var data = JSON.parse(raw);
        (data.dealBars || []).forEach(function (bar) {
          if (bar && bar.id && typeof bar.quantity === 'number') map[bar.id] = bar.quantity;
        });
      } catch (e) { /* ignore */ }
    });
    if (Object.keys(map).length) qtyById = map;
    return map;
  }

  /* One record per tier, read from the rendered widget. */
  function readTiers() {
    if (!block) return [];
    var bars = $$('.kaching-bundles__bar', block);
    var map = quantities();
    return bars.map(function (bar, i) {
      var id = bar.getAttribute('data-deal-bar-id');
      var qty = map[id] || (i + 1);
      var mainRow = $('.kaching-bundles__bar-pricing-row--main', bar) || bar;
      var priceEl = $('.kaching-bundles__bar-price', mainRow);
      var price = parseMoney(cleanText(priceEl));
      var perItem = !!(priceEl && $('.kaching-bundles__bar-price__unit-label', priceEl));
      var total = null;
      if (price) {
        total = perItem ? price.cents * qty : price.cents;
        var secondary = $('.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price', bar);
        if (perItem && secondary) {
          var t = parseMoney(cleanText(secondary));
          if (t) total = t.cents;
        }
      }
      var full = parseMoney(cleanText($('.kaching-bundles__bar-full-price', bar)));
      var copy = cfg.tiers.filter(function (t) { return Number(t.position) === i + 1; })[0] || {};
      return {
        el: bar,
        index: i,
        qty: qty,
        title: cleanText($('.kaching-bundles__bar-title', bar)),
        label: cleanText($('.kaching-bundles__bar-label', bar)),
        prefix: price ? price.prefix : '£',
        total: total,
        full: full && total !== null && full.cents > total ? full.cents : null,
        selected: bar.classList.contains('kaching-bundles__bar--selected'),
        note: copy.note || '',
        badge: copy.badge || ''
      };
    });
  }

  function deliveryFor(tier) {
    if (!cfg.showDelivery || tier.total === null) return null;
    var threshold = Number(cfg.freeThreshold) || 0;
    var free = threshold > 0 && tier.total >= threshold;
    var text = free ? cfg.deliveryFree : cfg.deliveryPaid;
    if (!text) return null;
    return { free: free, text: text };
  }
  function eachFor(tier) {
    if (!cfg.showEach || tier.qty < 2 || tier.total === null) return '';
    var per = Math.round(tier.total / tier.qty);
    return (cfg.eachLabel || '[price] each').replace('[price]', formatMoney(per, tier.prefix));
  }

  /* ------------------------------------------------------------ annotate */

  function ensureChild(parent, cls, tag, afterEl) {
    var el = $('.' + cls, parent);
    if (!el) {
      el = document.createElement(tag || 'span');
      el.className = cls;
      if (afterEl && afterEl.parentNode === parent) parent.insertBefore(el, afterEl.nextSibling);
      else parent.appendChild(el);
    }
    return el;
  }
  function removeChild(parent, cls) {
    var el = $('.' + cls, parent);
    if (el) el.parentNode.removeChild(el);
  }

  var lastTiers = null;
  var sheetPrimed = false;

  function annotate() {
    var tiers = readTiers();
    if (!tiers.length) return tiers;
    lastTiers = tiers;
    purchase.classList.add('has-picker');
    tiers.forEach(function (tier) {
      var left = $('.kaching-bundles__bar-content-left', tier.el);
      var container = $('.kaching-bundles__bar-container', tier.el);
      if (!left || !container) return;
      var firstLine = $('.kaching-bundles__bar-first-line', left);

      if (tier.note) {
        var sub = ensureChild(left, 'jt-tier__sub', 'span', firstLine);
        setText(sub, tier.note);
      } else {
        removeChild(left, 'jt-tier__sub');
      }

      var each = eachFor(tier);
      var ship = deliveryFor(tier);
      if (each || ship) {
        var meta = ensureChild(left, 'jt-tier__meta', 'span');
        var key = each + '|' + (ship ? (ship.free ? 'f:' : 'p:') + ship.text : '');
        if (meta.getAttribute('data-k') !== key) {
          meta.setAttribute('data-k', key);
          var html = '';
          if (each) html += '<span class="jt-tier__each"></span>';
          if (ship) html += '<span class="jt-tier__ship' + (ship.free ? ' jt-tier__ship--free' : '') + '">' + (ship.free ? CHECK_SVG : '') + '<span></span></span>';
          meta.innerHTML = html;
          if (each) meta.querySelector('.jt-tier__each').textContent = each;
          if (ship) meta.querySelector('.jt-tier__ship span').textContent = ship.text;
        }
      } else {
        removeChild(left, 'jt-tier__meta');
      }

      if (tier.badge) {
        var badge = ensureChild(container, 'jt-tier__badge', 'span');
        setText(badge, tier.badge);
      } else {
        removeChild(container, 'jt-tier__badge');
      }
    });
    syncSticky(tiers);
    syncPriceNote(tiers);
    if (sheetOpen) renderSheet(tiers);
    else if (!sheetPrimed && sheetList) {
      /* Build the (hidden) sheet once while the page is idle, so opening it
         later only has to show it (INP pass, 18 Oct 2026). */
      sheetPrimed = true;
      var prime = function () { if (!sheetOpen && lastTiers) renderSheet(lastTiers); };
      if (window.requestIdleCallback) window.requestIdleCallback(prime, { timeout: 2000 }); else window.setTimeout(prime, 200);
    }
    return tiers;
  }

  /* "or 2 for £133 with free delivery" beside the headline price. */
  var priceNote = $('[data-jt-price-note]');
  function syncPriceNote(tiers) {
    if (!priceNote) return;
    var t = tiers[(Number(cfg.priceNoteTier) || 2) - 1];
    if (!t || t.total === null || t.qty < 2) { setText(priceNote, ''); return; }
    var ship = deliveryFor(t);
    var tpl = (ship && ship.free && cfg.priceNoteFree) ? cfg.priceNoteFree : cfg.priceNote;
    if (!tpl) { setText(priceNote, ''); return; }
    setText(priceNote, tpl.replace('[qty]', t.qty).replace('[total]', formatMoney(t.total, t.prefix)));
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { queued = false; annotate(); });
  }

  function attach(found) {
    if (block === found) return;
    block = found;
    qtyById = null;
    new MutationObserver(schedule).observe(block, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  function findBlock() {
    var found = $('kaching-bundles-block', purchase) || $('kaching-bundles-block');
    if (found) attach(found);
    return !!found;
  }

  if (!findBlock()) {
    var waiter = new MutationObserver(function () { if (findBlock()) waiter.disconnect(); });
    waiter.observe(purchase, { childList: true, subtree: true });
    window.setTimeout(function () { waiter.disconnect(); findBlock(); }, 15000);
  }
  /* If the widget never draws, give the space back after 8 seconds. */
  window.setTimeout(function () {
    if (!$('.kaching-bundles__bar', purchase)) purchase.classList.add('is-skel-off');
  }, 8000);

  /* ------------------------------------------------------------ sticky + sheet */

  var stickyTitle = $('[data-jt-sticky-title]');
  var stickySub = $('[data-jt-sticky-sub]');
  var sheet = $('[data-jt-sheet]');
  var sheetList = sheet ? $('[data-jt-sheet-list]', sheet) : null;
  var sheetOpen = false;
  var lastFocus = null;

  function selectedTier(tiers) {
    return tiers.filter(function (t) { return t.selected; })[0] || tiers[0];
  }

  function syncSticky(tiers) {
    if (!stickyTitle || !tiers.length) return;
    var t = selectedTier(tiers);
    if (!t || t.total === null) return;
    setText(stickyTitle, prettyTitle(t.title) + ' · ' + formatMoney(t.total, t.prefix));
    var ship = deliveryFor(t);
    setText(stickySub, ship ? ship.text : '');
  }

  function renderSheet(tiers) {
    if (!sheetList) return;
    tiers = tiers || readTiers();
    var key = tiers.map(function (t) { return [t.title, t.total, t.selected, t.label].join(':'); }).join('|');
    if (sheetList.getAttribute('data-k') === key) return;
    /* Same tiers, only the selection moved: update the radios in place rather
       than rebuilding every option (INP pass, 18 Oct 2026). */
    var shape = tiers.map(function (t) { return [t.title, t.total, t.label, t.note, t.badge, t.full].join(':'); }).join('|');
    var existing = $$('.jt-opt', sheetList);
    if (sheetList.getAttribute('data-shape') === shape && existing.length === tiers.length) {
      sheetList.setAttribute('data-k', key);
      tiers.forEach(function (t, i) { existing[i].setAttribute('aria-checked', t.selected ? 'true' : 'false'); });
      return;
    }
    sheetList.setAttribute('data-shape', shape);
    sheetList.setAttribute('data-k', key);
    var hadFocus = sheetList.contains(document.activeElement);
    sheetList.innerHTML = '';
    tiers.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jt-opt';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', t.selected ? 'true' : 'false');
      b.innerHTML =
        (t.badge ? '<span class="jt-tier__badge"></span>' : '') +
        '<span class="jt-opt__radio" aria-hidden="true"></span>' +
        '<span class="jt-opt__main"><span class="jt-opt__line1"><span class="jt-opt__title"></span>' + (t.label ? '<span class="jt-opt__save"></span>' : '') + '</span>' +
        (t.note ? '<span class="jt-tier__sub"></span>' : '') +
        '<span class="jt-tier__meta"></span></span>' +
        '<span class="jt-opt__price"><b></b>' + (t.full ? '<s></s>' : '') + '</span>';
      if (t.badge) b.querySelector('.jt-tier__badge').textContent = t.badge;
      b.querySelector('.jt-opt__title').textContent = t.title;
      if (t.label) b.querySelector('.jt-opt__save').textContent = t.label;
      if (t.note) b.querySelector('.jt-tier__sub').textContent = t.note;
      var meta = b.querySelector('.jt-tier__meta');
      var each = eachFor(t);
      var ship = deliveryFor(t);
      if (each) { var e = document.createElement('span'); e.className = 'jt-tier__each'; e.textContent = each; meta.appendChild(e); }
      if (ship) {
        var s = document.createElement('span');
        s.className = 'jt-tier__ship' + (ship.free ? ' jt-tier__ship--free' : '');
        s.innerHTML = (ship.free ? CHECK_SVG : '') + '<span></span>';
        s.lastChild.textContent = ship.text;
        meta.appendChild(s);
      }
      if (!each && !ship) meta.parentNode.removeChild(meta);
      b.querySelector('.jt-opt__price b').textContent = t.total !== null ? formatMoney(t.total, t.prefix) : '';
      if (t.full) b.querySelector('.jt-opt__price s').textContent = formatMoney(t.full, t.prefix);
      b.addEventListener('click', function () { chooseTier(t.index); });
      sheetList.appendChild(b);
    });
    if (hadFocus) {
      var checked = $('.jt-opt[aria-checked="true"]', sheetList);
      if (checked) { try { checked.focus({ preventScroll: true }); } catch (e) { checked.focus(); } }
    }
  }

  function chooseTier(index) {
    var bars = block ? $$('.kaching-bundles__bar', block) : [];
    var bar = bars[index];
    if (!bar) return;
    if (bar.classList.contains('kaching-bundles__bar--selected')) return;
    var target = $('.kaching-bundles__bar-main', bar) || $('label', bar) || $('input', bar);
    if (target) target.click();
    window.setTimeout(function () {
      if (!bar.classList.contains('kaching-bundles__bar--selected')) {
        var input = $('input[type="radio"]', bar);
        if (input) input.click();
      }
      schedule();
    }, 60);
  }

  function openSheet() {
    if (!sheet || sheetOpen) return;
    /* The tiers read on the last widget change are still current unless a
       re-read is already queued, so skip reading the widget again. */
    var tiers = (!queued && lastTiers && lastTiers.length) ? lastTiers : annotate();
    if (!tiers || !tiers.length) {
      var anchor = $('.product__purchase');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (anchor) window.scrollTo({ top: anchor.getBoundingClientRect().top + window.scrollY - 90, behavior: calm ? 'auto' : 'smooth' });
      return;
    }
    sheetOpen = true;
    lastFocus = document.activeElement;
    renderSheet(tiers);
    sheet.hidden = false;
    document.documentElement.classList.add('jt-sheet-open');
    // Next frame so the slide-up transition runs.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    });
    var panel = $('.jt-sheet__panel', sheet);
    window.setTimeout(function () {
      var checked = $('.jt-opt[aria-checked="true"]', sheet) || panel;
      try { checked.focus({ preventScroll: true }); } catch (e) { checked.focus(); }
    }, 60);
  }
  function closeSheet() {
    if (!sheet || !sheetOpen) return;
    sheetOpen = false;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('jt-sheet-open');
    window.setTimeout(function () { if (!sheetOpen) sheet.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }

  $$('[data-jt-sheet-open]').forEach(function (el) { el.addEventListener('click', openSheet); });

  /* Sticky button. Before the visitor has reached the picker (bar mode
     "before"), it opens the pack sheet so they choose a pack first. Once they
     have scrolled past the picker (mode "past"), it adds the chosen pack
     straight away. theme.js sets data-mode; this listener runs in the capture
     phase so it can stop theme.js's direct submit in "before" mode. */
  var bar = $('[data-sticky-bar]');
  var stickyBtn = bar ? $('[data-sticky-cta]', bar) : null;
  if (bar && stickyBtn && sheet) {
    var stickyLabel = $('[data-sticky-cta-label]', stickyBtn);
    var labels = { before: stickyBtn.getAttribute('data-label-before'), past: stickyBtn.getAttribute('data-label-past') };
    stickyBtn.addEventListener('click', function (e) {
      if (bar.getAttribute('data-mode') === 'before') {
        e.preventDefault();
        e.stopImmediatePropagation();
        openSheet();
      }
    }, true);
    var applyMode = function () {
      var mode = bar.getAttribute('data-mode') === 'before' ? 'before' : 'past';
      var text = labels[mode];
      if (!stickyLabel || !text || stickyBtn.disabled) return;
      stickyLabel.setAttribute('data-label', text);
      setText(stickyLabel, text);
    };
    new MutationObserver(applyMode).observe(bar, { attributes: true, attributeFilter: ['data-mode'] });
    applyMode();
  }
  if (sheet) {
    $$('[data-jt-sheet-close]', sheet).forEach(function (el) { el.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) {
      if (sheetOpen && e.key === 'Escape') { e.preventDefault(); closeSheet(); }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        /* Keep focus inside the open sheet. */
        var focusable = $$('button:not([disabled]), a[href]', sheet).filter(function (el) { return el.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var opts = $$('.jt-opt', sheet);
        var i = opts.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var next = opts[(i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
        next.focus();
      }
    });
    var sheetCta = $('[data-jt-sheet-cta]', sheet);
    if (sheetCta) {
      sheetCta.addEventListener('click', function () {
        var form = $('form[data-type="add-to-cart-form"]', purchase);
        var submit = form ? $('[data-add-to-cart]', form) : null;
        if (!form || !submit || submit.disabled || sheetCta.classList.contains('is-busy')) return;
        var toCheckout = form.getAttribute('data-after-add') === 'checkout';
        sheetCta.classList.add('is-busy');
        var original = sheetCta.innerHTML;
        sheetCta.setAttribute('data-label-original', original);
        if (toCheckout) sheetCta.textContent = form.getAttribute('data-busy-label') || 'Going to checkout…';
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
        /* In checkout mode the page is about to change; restore only if it did not. */
        window.setTimeout(function () {
          sheetCta.classList.remove('is-busy');
          sheetCta.innerHTML = original;
          if (!toCheckout) closeSheet();
        }, toCheckout ? 6000 : 400);
      });
    }
  }

  /* ------------------------------------------------------------ gallery progress */

  var gallery = $('.jt-gallery [data-gallery]');
  var prog = $('[data-jt-gprog]');
  if (gallery && prog) {
    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var slides = $$('[data-gallery-slide]', gallery);
        if (!slides.length) return;
        var origin = slides[0].offsetLeft;
        var best = 0, dist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs((s.offsetLeft - origin) - gallery.scrollLeft);
          if (d < dist) { dist = d; best = i; }
        });
        // The last slides cannot snap to the start; count reaching the end as the last image.
        if (gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 4) best = slides.length - 1;
        prog.style.setProperty('--i', best);
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------ dispatch date */

  var dispatchEls = $$('[data-jt-dispatch]');
  if (dispatchEls.length && window.Intl && Intl.DateTimeFormat) {
    try {
      var tz = 'Europe/London';
      var now = new Date();
      var wdName = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short' }).format(now);
      var add = { Thu: 4, Fri: 4, Sat: 3 }[wdName] || 2; /* two working days, matches the policy (19 Oct 2026) */
      var target = new Date(now.getTime() + add * 86400000);
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', day: 'numeric', month: 'short' }).formatToParts(target);
      var get = function (type) { var p = parts.filter(function (x) { return x.type === type; })[0]; return p ? p.value : ''; };
      var label = get('weekday') + ' ' + get('day') + ' ' + get('month');
      dispatchEls.forEach(function (el) { setText(el, label); });
    } catch (e) { /* keep the server date */ }
  }

  /* Back-forward cache: a visitor returning from checkout gets a working button. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    $$('.jt-cta').forEach(function (b) { b.classList.remove('is-busy'); });
    /* Returning from checkout restores the page from cache with the sheet CTA
       still reading "Going to checkout…" and the sheet still open. */
    var sheetCtaEl = sheet ? $('[data-jt-sheet-cta]', sheet) : null;
    if (sheetCtaEl && sheetCtaEl.getAttribute('data-label-original')) sheetCtaEl.innerHTML = sheetCtaEl.getAttribute('data-label-original');
    if (sheetOpen) closeSheet();
  });
})();
